var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3312 20.6981L31.011 20.3882C30.218 19.5515 30.3553 19.1641 31.133 18.3739L35.2808 14.1127C36.516 12.8421 36.7447 12.2378 37.9189 13.3689L38.2391 13.6788L31.3312 20.6981ZM32.1394 21.3954L38.8491 14.5775C39.9166 16.0341 42.4174 19.9544 41.1822 22.852C40.0691 25.4396 39.5201 25.5636 38.1324 27.5005C35.3113 30.77 31.7582 34.2719 28.9828 36.906C27.0614 38.3161 26.9852 38.9669 24.408 40.0051C21.6632 41.1052 17.6984 38.626 16.2039 37.5878L22.9136 30.77L24.713 33.2802C25.2315 33.993 26.5429 33.1872 27.4579 32.2575C29.0438 30.6305 32.3072 27.33 33.5576 25.951C34.4573 25.0368 35.2655 23.7042 34.5641 23.1619L32.1394 21.3954ZM15.3347 36.968L15.0145 36.6426C13.9775 35.496 14.5722 35.2481 15.8074 34.0084L19.9857 29.7938C20.7635 29.0345 21.1294 28.8641 21.9224 29.6233L22.2274 29.9487L15.3347 36.968Z",
    fill: "#FD8298"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55C13.0883 55 1 42.9117 1 28H-1C-1 44.0163 11.9837 57 28 57V55ZM55 28C55 42.9117 42.9117 55 28 55V57C44.0163 57 57 44.0163 57 28H55ZM28 1C42.9117 1 55 13.0883 55 28H57C57 11.9837 44.0163 -1 28 -1V1ZM28 -1C11.9837 -1 -1 11.9837 -1 28H1C1 13.0883 13.0883 1 28 1V-1Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ab71b4528808e23d7b095c99859ba8c1.svg";
export { ForwardRef as ReactComponent };